import { confirmedCancellationNoShow } from "../../utils/realTimeUtils"

/**
 * Gets all patients that are cancelled or no-show and in editedPatients
 * @param {Schedule} todaySchedule
 * @returns {Array<Patient>} a list of these patients sorted by acuity high to low
 */
const getRemovedPatients = todaySchedule => {
	const removedPatients = []

	for (const patient of todaySchedule.patientSchedule) {
		if (patient.cancellationConsideredForReassignment) {
			continue
		}
		if (confirmedCancellationNoShow(patient)) {
			removedPatients.push(patient)
		}
	}

	return removedPatients.sort((a, b) => b.acuity - a.acuity)
}

export default getRemovedPatients
